import React, { PropTypes } from 'react';
import classNames from 'classnames';


const Cell = ({ className, sortParam, children }, { sortBy, sortDesc }) => (
  <td
    className={classNames(className, sortParam, {
      sort: sortParam === sortBy,
      [`sort-${sortDesc ? 'desc' : 'asc'}`]: sortParam === sortBy,
    })}
  >
    { children }
  </td>
);

Cell.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  sortParam: PropTypes.string,
};

Cell.defaultProps = {
  children: null,
  className: null,
  sortParam: null,
};

Cell.contextTypes = {
  sortBy: PropTypes.string.isRequired,
  sortDesc: PropTypes.bool.isRequired,
};

export default Cell;



// WEBPACK FOOTER //
// ./app/scripts/views/App/views/UserRankings/User/Cell.jsx